import axios from "axios";
import authHeader from "./auth-header";

import constants from '../../constants/constant.js';


const changeUserStatus = (data)=>{
    if(!data.id){
        return Promise.reject({error:'no id'});
    }
        return axios.post(constants.URL + `api/v1/clubs/${data.id}/${data.type}`,{...data},{ headers: authHeader()})
        .then((response) => { 
            return response.data})
        .catch((e)=>{
              
            console.log(e);
        });
}

const getUserHeads = (data)=>{
    if(!data.id){
        return Promise.reject({error:'no id'});
    }
    return axios.get(constants.URL + `api/v1/clubs/${data.id}/participants/heads`,{ headers: authHeader()})
    .then((response) => { 
        return response.data})
    .catch((e)=>{
          
        console.log(e);
    });

}

const getUserMembers = (data)=>{
    if(!data.id){
        return Promise.reject({error:'no id'});
    }
    return axios.get(constants.URL + `api/v1/clubs/${data.id}/participants/members`,{ headers: authHeader()})
    .then((response) => { 
        return response.data})
    .catch((e)=>{
          
        console.log(e);
    });

}

const getUserApplying = (data)=>{
    if(!data.id){
        return Promise.reject({error:'no id'});
    }

    return axios.get(constants.URL + `api/v1/clubs/${data.id}/participants/applying`,{ headers: authHeader()})
    .then((response) => { 
        return response.data})
    .catch((e)=>{
          
        console.log(e);
    });

}


export default{
    changeUserStatus,
    getUserApplying,
    getUserMembers,
    getUserHeads,
}